var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 82,
    viewBox: "0 0 78 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3135_63741",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 82
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7661 1.93248L5.4982 12.3827C4.16745 13.0689 3.3313 14.4408 3.3313 15.938V66.2137C3.3313 67.7188 4.17613 69.0965 5.51759 69.7789L25.7733 80.0836C26.906 80.6598 28.2451 80.6635 29.381 80.0935L74.192 57.607C75.5443 56.9284 76.398 55.5449 76.398 54.0319V27.9681C76.398 26.4551 75.5443 25.0716 74.192 24.393L29.3933 1.9126C28.2505 1.33916 26.9025 1.34655 25.7661 1.93248Z",
    stroke: "#07285D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6647 54.3333L52.6647 41",
    stroke: "#07285D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6647 27.333L52.6647 40.9997",
    stroke: "#07285D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6594 27.333V41.3641V48.9242V52.7043",
    stroke: "#07285D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1647 67.9997L2.66467 40.9997L27.4147 27.1663L52.1647 13.333V67.9997Z",
    stroke: "#07285D",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 13.3333,
    r: 2.83333,
    fill: "#07285D",
    stroke: "#07285D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 68.0003,
    r: 2.83333,
    fill: "#07285D",
    stroke: "#07285D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 41.0003,
    r: 2.83333,
    fill: "#07285D",
    stroke: "#07285D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6667,
    cy: 54.3333,
    r: 2.83333,
    fill: "#07285D",
    stroke: "#07285D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.33333,
    cy: 41.0003,
    r: 2.83333,
    fill: "#07285D",
    stroke: "#07285D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6667,
    cy: 27.3333,
    r: 2.83333,
    fill: "#07285D",
    stroke: "#07285D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3135_63741)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 82,
    fill: "url(#paint0_linear_3135_63741)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3135_63741",
    x1: 0,
    y1: 0,
    x2: 78,
    y2: 82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07285D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBFC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.48aefa691b83b697f91c20858be49096.svg";
export { ForwardRef as ReactComponent };